import React, { ReactNode } from 'react';
import { theme } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from 'store/configureStore';
import { ITextBoxProps } from 'store/ducks/Tasks/types';
import * as Styled from './TextBox.styled';

const { useToken } = theme;

const TextBox: React.FC<ITextBoxProps> = ({
  width,
  level,
  children,
  scheme,
  ...rest
}) => {
  const { token } = useToken();
  const globalScheme = useSelector((state: RootState) => state.global.scheme);
  const currentScheme = scheme || globalScheme;

  return (
    <Styled.StyledBox
      token={token}
      width={width}
      level={level}
      scheme={currentScheme}
      {...rest}
    >
      {children}
    </Styled.StyledBox>
  );
};

export default TextBox;
